// components/RoleBasedRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface RoleBasedRouteProps {
  children: React.ReactNode;
  allowedRoles: ('user' | 'admin' | 'formateur')[];
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-accent">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00088E] mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Vérification des permissions...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to signin with the current location
  if (!user) {
    return (
      <Navigate
        to="/signin"
        state={{ from: location }}
        replace
      />
    );
  }

  // ✅ FIXED: Strict role-based access control
  if (!allowedRoles.includes(user.role)) {
    // Fixed: Use a function or object mapping to avoid TypeScript narrowing issues
    const getRedirectPath = (role: 'user' | 'admin' | 'formateur'): string => {
      switch (role) {
        case 'admin':
          return '/admin';
        case 'formateur':
          return '/formateur';
        case 'user':
        default:
          return '/dashboard';
      }
    };

    const redirectPath = getRedirectPath(user.role);

    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

export default RoleBasedRoute;
